import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-9e6dc9e3.js';
import 'classnames';

var AndroidAuto = createSvgIcon(React__default.createElement("path", { d: "M10.8338 4.94365L12 3L13.1662 4.94365L19.8 16L21 18H18.6676H16.2857L18 21L12 18.25L6 21L7.71428 18H5.33238L3 18L4.2 16L10.8338 4.94365ZM15.1429 16L12 10.5L8.85714 16H6.53238L12 6.8873L17.4676 16H15.1429Z", fillRule: "evenodd" }), 'AndroidAuto');

export { AndroidAuto };
